import { AuditSocialMediaCarouselController } from './audit-social-media-carousel.controller'

function auditSocialMediaCarousel () {
  return {
    restrict: 'E',
    scope: {
      post: '<',
      isPreview: '<'
    },
    templateUrl: '/audit/directives/audit-social-media-carousel/audit-social-media-carousel.html?$$REVISION$$',
    controller: AuditSocialMediaCarouselController
  }
}

export { auditSocialMediaCarousel }
